const getTime = (step) => step ? step.minute : null

export const getRoundSteps = (steps) => {
    const roundSteps = []
    steps.forEach((step, index) => {
      const roundStep = {
        step: steps[index],
        minValue: (getTime(step) - 1) / 60,
        maxValue: getTime(step) / 60
      }
      roundSteps.push(roundStep)
    })
    return roundSteps
}

export const getStepValue = (v, roundSteps) => {
  let stepValue = roundSteps[0]
  for (var index=roundSteps.length-1; index >= 0; index--) {
    if (roundSteps[index].minValue < v) {
      stepValue = roundSteps[index]
      break
    }
  }
  return stepValue
}

export const getRoundStepFromMinute = (minute, roundSteps) => {
  return roundSteps.find(({step}) => step.minute === minute)
}